import { Component, computed, input, output, signal, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'ui-select-input',
	templateUrl: './select-input.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class SelectInputComponent {
	inputId = input<string>('');
	placeholder = input<string>('');
	disabled = input<boolean>(false);
	hasError = input<boolean>(false);
	opened = input<boolean>(false);
	showWhenValid = input<boolean>(false);
	value = input<string>('');
	amountSelected = input<number>(0);
	showClearButton = input<boolean>(false);
	loadedOptionsCount = input<number>(0);
	tabindex = input<number>(0);
	isMultiple = input<boolean>(false);
	translatedAll = input<string>('All');
	optionsComplete = input<boolean>(true);
	searchOpen = input<boolean>(false);

	clearSelection = output<void>();
	keyPressed = output<KeyboardEvent>();

	showAllSummary = computed(
		() =>
			this.isMultiple() &&
			this.optionsComplete() &&
			this.loadedOptionsCount() > 0 &&
			this.amountSelected() === this.loadedOptionsCount()
	);

	showOverflowPill = computed(
		() =>
			this.amountSelected() > 1 &&
			(!this.optionsComplete() || this.amountSelected() < this.loadedOptionsCount())
	);

	focused = signal<boolean>(false);

	onClearSelection($event: any): void {
		$event.stopImmediatePropagation();
		$event.preventDefault();
		this.clearSelection.emit();
	}

	onKeyDown(event: KeyboardEvent): void {
		this.keyPressed.emit(event);
	}

	onFocus(): void {
		this.focused.set(true);
	}

	onBlur(): void {
		this.focused.set(false);
	}
}
